/** Real brand marks from @lobehub/icons-static-svg + Simple Icons / brand favicons. */

const SRC: Record<string, string> = {
  groq: "/providers/groq.svg",
  cerebras: "/providers/cerebras.svg",
  fireworks: "/providers/fireworks.svg",
  gemini: "/providers/gemini.svg",
  openai: "/providers/openai.svg",
  mistral: "/providers/mistral.svg",
  bedrock: "/providers/bedrock.svg",
  deepgram: "/providers/deepgram.svg",
  cartesia: "/providers/cartesia.png",
  elevenlabs: "/providers/elevenlabs.svg",
  heygen: "/providers/heygen.png",
  // LiveAvatar is HeyGen's realtime product; reuse the mark until a dedicated asset lands.
  liveavatar: "/providers/heygen.png",
};

export function ProviderMark({
  provider,
  size = 22,
}: {
  provider: string;
  size?: number;
}) {
  const key = (provider || "").toLowerCase().trim();
  const src = SRC[key];
  if (!src) {
    return (
      <span
        className="provider-mark fallback"
        title={provider}
        style={{ width: size, height: size, fontSize: Math.max(8, Math.round(size * 0.4)) }}
      >
        {(provider || "?").slice(0, 1).toUpperCase()}
      </span>
    );
  }
  return (
    <span className="provider-mark" title={provider} style={{ width: size, height: size }}>
      <img src={src} alt="" width={size - 4} height={size - 4} draggable={false} />
    </span>
  );
}

export function hasProviderMark(provider: string): boolean {
  return Boolean(SRC[(provider || "").toLowerCase().trim()]);
}
